import flatten from 'lodash/flatten';
export const mapOptionsGroupValues = ({ options, }) => {
    return options.map(option => option.value);
};
export const gatherValues = (options) => {
    const values = options.map(option => {
        if ('value' in option) {
            return option.value;
        }
        return mapOptionsGroupValues(option);
    });
    return flatten(values);
};
//# sourceMappingURL=utils.js.map